import { render } from "./omHome.vue?vue&type=template&id=9bc471d2&scoped=true"
import script from "./omHome.vue?vue&type=script&lang=js"
export * from "./omHome.vue?vue&type=script&lang=js"

import "./omHome.vue?vue&type=style&index=0&id=9bc471d2&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc471d2"]])

export default __exports__